import React from 'react';
import { useMount } from 'react-use';
import { LowResults, NoResults } from './components/EmptyState';
import { withMainControls } from '@eb/eds-structure';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getCanonicalSearchUrl, collectionsDuck } from '@eb/redux-destination';
import * as analytics from '@eb/site-analytics';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleApplyFilterSimple as handleApplyFilterSimpleAction,
    searchSuggestionsForCity as searchSuggestionsForCityAction,
} from '../../../../redux/actions/search';
import { addSearchIdToGaAction } from '../../utils/analytics';

import {
    isNextDisabled,
    hasEventResults,
    getTrendingSearchData,
    getEventSuggestions,
    getParsedSuggestedFilters,
    getRandomizedSuggestedTags,
} from './selectors';

import {
    TagSuggestions,
    FilterSuggestions,
    EventSuggestions,
} from './components/Suggestions';

import { GA_SEARCH_REDIRECTION_CATEGORY } from './constants';

const SearchPivotSuggestions = (props) => {
    const { trackGAEvent } = props;

    //TODO: trigger this on scroll into view as opposed to on mount
    useMount(() => {
        trackGAEvent({
            action: 'EndResultsSectionShown',
            nonInteraction: true,
        });
    });

    return (
        <>
            <section className="search-result-pivots__empty-state">
                {props.hasEventResults ? (
                    <LowResults containerClassname="eds-l-pad-hor-6" />
                ) : (
                    <NoResults
                        containerClassname="eds-l-pad-hor-6"
                        isOrganizationsSearch={props.isOrganizationsSearch}
                        isOnlineSearch={props.isOnlineSearch}
                        currentPlace={props.currentPlace}
                    />
                )}
            </section>
            <EventSuggestions {...props} />
            <TagSuggestions {...props} />
            <FilterSuggestions {...props} />
        </>
    );
};

const _mapStateToProps = (state) => ({
    isLoading: state.pagination.loading,
    isNextDisabled: isNextDisabled(state),
    hasEventResults: hasEventResults(state),
    userCollections: collectionsDuck.selectors.getFormattedCollections(state),
    featureFlags: state.app.featureFlags,
    suggestionsLoading: state.suggestions.loading,
    eventSuggestions: getEventSuggestions(state),
    suggestedFilters: getParsedSuggestedFilters(state),
    suggestedTags: getRandomizedSuggestedTags(state),
    isAuthenticated: state.auth.isAuthenticated,
    shareOptions: state.share.options,
    allEventsUrl: getCanonicalSearchUrl({ slug: state.location.slug }),
    trackGAEvent: (action) =>
        analytics.trackEventFromState(
            state,
            addSearchIdToGaAction(
                { ...action, category: GA_SEARCH_REDIRECTION_CATEGORY },
                state,
            ),
        ),
    trackGAEventOnPageUnload: (action) =>
        analytics.trackEventFromStateOnPageUnload(
            state,
            addSearchIdToGaAction(
                {
                    ...action,
                    category: GA_SEARCH_REDIRECTION_CATEGORY,
                },
                state,
            ),
        ),
    trendingSearchData: getTrendingSearchData(
        state.location,
        state.app.domain,
        state.shouldShowTrendingSearchPageLink,
    ),
    isOnlineSearch: state.location.slug == 'online',
    currentPlace: state.location.currentPlace,
    isOrganizationsSearch: state.search.eventSearch.organizationsOr.length,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    onAddOrRemoveEventToCollection: (...args) =>
        dispatch(
            collectionsDuck.actions.addOrRemoveEventToCollection(
                GA_SEARCH_REDIRECTION_CATEGORY,
            )(...args),
        ),
    onCreateCollection: (...args) =>
        dispatch(
            collectionsDuck.actions.createCollection(
                GA_SEARCH_REDIRECTION_CATEGORY,
            )(...args),
        ),
    handleApplyFilter: (...args) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleApplyFilterSimple: (...args) =>
        dispatch(handleApplyFilterSimpleAction(ownProps.history, ...args)),
    searchSuggestionsForCityAction: (...args) =>
        dispatch(searchSuggestionsForCityAction(...args)),
});

const enhance = compose(
    withMainControls,
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
);

export default enhance(SearchPivotSuggestions);
